module.exports = __webpack_public_path__ + "img/tag-extra-reward.6674d32a.png";